import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Toast, ToastContainer } from 'react-bootstrap';

import { hideSnapshotFailedToast } from '../../store/toasts';

const SnapshotFailedToast = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector((store) => store.toasts.snapshotFailed);

  return (
    <ToastContainer position="top-center" style={{ position: 'fixed', zIndex: 1100 }}>
      <Toast
        onClose={() => dispatch(hideSnapshotFailedToast())}
        show={isVisible}
        bg="warning"
        delay={5000}
        autohide
      >
        <Toast.Body className="text-white">Snapshot taking has failed</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default SnapshotFailedToast;
